import { USER_LOGGED_OUT, USER_SESSION_OUT } from "../actions/UserActions";

const initialState = {
  monthsBack: 1,
};

const settingsReducer = function (state = initialState, action) {
  switch (action.type) {
    case "UPDATE_SETTINGS": {      
      return {
        ...state,
        ...action.payload,
      };
    }
    case USER_LOGGED_OUT: {
      return initialState;
    }
    case USER_SESSION_OUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default settingsReducer;
